import { stripTrailingSlash } from './normalizePathname';

/**
 * Ensures that the given url ends with a trailing slash
 */
const ensureTrailingSlash = (url?: string) => `${stripTrailingSlash(url)}/`;

export default ensureTrailingSlash;
